export default __webpack_public_path__ + "static/media/warning--junction-with-merge-from-right--g1.9d27fd5a.png";